import axios from '../http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块,post数据需要qs格式化
import base from './base'// 导入接口域名列表
//相关接口
;

const myAllWork = {
  //列表数据
  getPage(params) {
    // console.log("----我使用新的了-----"+params)
    return axios.post(`${base.bs}/admin/sys/tabFiles/page`, params);
  },
  //根据id查询单个信息
  getById(params) {
    return axios.get(`${base.bs}/admin/sys/tabFiles/get/${params.id}`)
  },
  //保存修改
  saveOrUpdate(params,config) {
    return axios.post(`${base.bs}/admin/sys/tabFiles/set`, params,config)
  },
  //根据id删除单个
  del(params) {
    return axios.get(`${base.bs}/admin/sys/tabFiles/del/${params.id}`)
  },
  //批量上传多个附件
  uploadfile(params,config) {
    return axios.post(`${base.bs}/admin/sys/tabFiles/uploadfile/`,params,config)
  },
  //上传一个附件，返回path
  uploadfileRePath(params,config) {
    return axios.post(`${base.bs}/admin/sys/tabFiles/uploadfileRePath/`,params,config)
  },
  //上传一个附件，返回path
  uploadImgRePathBatch(params,config) {
    return axios.post(`${base.bs}/admin/sys/tabFiles/uploadImgRePathBatch/`,params,config)
  },
  //上传一个图片，返回path
  uploadImgRePath(params,config) {
    return axios.post(`${base.bs}/admin/sys/tabFiles/uploadImgRePath/`,params,config)
  },
  //根据dataid获取图片
  getList(params) {
    return axios.get(`${base.bs}/admin/sys/tabFiles/getList/${params.dataid}`)
  },

}
// 导出接口
export default myAllWork;



// WEBPACK FOOTER //
// ./src/request/api/upFiles.js